// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".agreementName[data-v-68c200cd] {\n  text-align: center;\n  font-size: 20px;\n  font-weight: bolder;\n}\n", ""]);
// Exports
module.exports = exports;
